module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tg-2e6abed3190a0d75a5649492c936b1dd.svg";